// AuthForm.jsx
import React, { useState } from 'react';
import api from '../../api';

export default function AuthForm({ onAuthSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [inviteCode, setInviteCode] = useState('');
  const [mode, setMode] = useState('login');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const endpoint = mode === 'login' ? '/auth/login' : '/auth/register';
      const payload = { email, password };
      if (mode === 'register') payload.inviteCode = inviteCode;

      const res = await api.post(endpoint, payload);
      if (res.data.token) {
        localStorage.setItem('lyraToken', res.data.token);
        onAuthSuccess();
      } else {
        // Registration returns a success message but no token; prompt login.
        setMode('login');
        setError('Registration successful — please log in.');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Authentication failed.');
    }
  };

  return (
    <div className="max-w-md mx-auto p-4 border rounded shadow">
      <h2 className="text-xl font-bold mb-4">{mode === 'login' ? 'Login' : 'Register'}</h2>
      <form onSubmit={handleSubmit} className="space-y-3">
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full border p-2 rounded"
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full border p-2 rounded"
          required
        />
        {mode === 'register' && (
          <input
            type="text"
            placeholder="Invite Code"
            value={inviteCode}
            onChange={(e) => setInviteCode(e.target.value)}
            className="w-full border p-2 rounded"
            required
          />
        )}
        {error && <p className="text-red-600 text-sm">{error}</p>}
        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
        >
          {mode === 'login' ? 'Login' : 'Register'}
        </button>
      </form>
      <p className="mt-2 text-sm text-center">
        {mode === 'login' ? (
          <>Need an account? <button onClick={() => setMode('register')} className="text-blue-500 underline">Register</button></>
        ) : (
          <>Already have an account? <button onClick={() => setMode('login')} className="text-blue-500 underline">Login</button></>
        )}
      </p>
    </div>
  );
}
